import React from "react";
import TotalUsers from "../components/pages/Dashboard/TotalUsers";
import SideNav from "../components/SideNav/sideNav";
import Header from "../components/Header/hearder";
import { Wrapper } from "./layout.styles";

const TotalUsersLayout = () => {
  return (
    <React.Fragment>
      <Header />
      <Wrapper>
        <SideNav />
        <div style={{margin: "70px 0px 0px 200px", width: "100%"}}>
        <TotalUsers />
        </div>
      </Wrapper>
    </React.Fragment>
  );
};

export default TotalUsersLayout;